<template>
  <div class="ClaimStep2">
    <div class="loading" id="loading" v-show = "loading"><div class="circle"></div></div>
    <div class="model">
        <div class="body">
            <p class="title"></p>
            <p class="content"></p>
            <p class="foot"></p>    
        </div>
    </div>
    <div class="loading" id="loading" style="display: none;"><div class="circle"></div></div>
    <div class="main" style="padding-bottom: 50px;">
        <p class="doc_title" style="margin-bottom:10px;">如果您的资金不幸被盗，请按以下步骤进行索赔登记</p>
        <p class="doc_text">1.手持身份证拍照（正反面）</p>
        <form method="post" action="" enctype="multipart/form-data">
    
        <div class="upload">
            <div class="item item1"><input type="file" class="btn_file" id="uploadIDFront" name="uploadIDFront" value="" accept="image/*"><button>上传照片</button><div class="desc">已上传</div></div>
            <div class="item item2"><input type="file" class="btn_file" id="uploadIDBack" name="uploadIDBack" value="" accept="image/*"><button>上传照片</button><div class="desc">已上传</div></div>    
        </div>
        <p class="doc_text" style="margin-top:20px">2.被盗信息截屏</p>
        <div class="upload">
        <div class="item screenShot"><input type="file" class="btn_file" id="uploadPrice" name="uploadPrice" value="" accept="image/*"><button>上传照片</button><div class="desc">已上传</div></div>
        </div>
        <p class="button" style="margin-top:25px;" @click="claimStep2">
            确认登记
        </p>
        </form>
        <p class="doc_a" style="margin-top: 15px;"><router-link to="/claimFlow">了解索赔流程</router-link></p>
    </div>
  </div>
</template>

<script>
import Toast from '@/components/toast'
const AES = require('@/lib/Utils/AES').default

export default {
  name: 'ClaimStep2',
  mounted:function(){
      var _self = this;
      _self.order_sn = this.$route.query.order_sn,
      
      Utils.Bridge.call('getAppInfo',{
        success:function(o){
            _self.appinfo = o;
            _self.loadCardPics();
            _self.loadPricePics();
            _self.bindEvent();
        }
    });
    //   Utils.Tracker.send({
    //     data: {
    //         f: 'wifiins',
    //         b: 'ins_sppage'
    //     }
    // });
    _self.$trace.enterTraceDone({page: 7, step: 2})

  },
  data () {
    return {
        appinfo: '',
        order_sn:'',
        loading:false
    }
  },
    methods:{
        claimStep2:function(){
            var _self = this;
            _self.$trace.trace('ins_claim_confirm', {step: 2,  type: 'ind' })
            var params = {
                "dhid":_self.appinfo.dhid,
                "uhid":_self.appinfo.uhid,
                "vcode":_self.appinfo.vcode
            };
            var error = false,
                msg = '';
            params.order_sn = _self.order_sn;

            $('.upload .item').each(function(index,ele){
                if($(ele).data('upload')+''!='true'){
                    error = true;
                    switch(index){
                        case 0 :
                            msg = '身份证正面';
                            break;
                        case 1 :
                            msg = '身份证反面';
                            break;
                        case 2 :
                            msg = '被盗信息截屏';
                            break;
                    }
                    return false;
                }
            });
            if(error){
                safe.model({
                    title:'温馨提示',
                    content:msg+'未上传完成',
                    foot:'我知道了'
                });
                safe.bindModelEvent();
                return;
            }
            // Utils.Tracker.send({
            //     data: {
            //         f: 'wifiins',
            //         b: 'ins_sp2'
            //     }
            // });
          let ed = AES.Encrypt( JSON.stringify(params), AES.obj())
            this.$http.post(_host + '/safe/order_sec',{ed: ed},{
                emulateJSON: true
            }).then(function(response){
                var json = response.body;
                if(json.c=='0000'){
                    _self.$router.push("/claimSuccess");
                }else{
                    safe.model({
                        title:'温馨提示',
                        content:json.m,
                        foot:'我知道了'
                    });
                    safe.bindModelEvent();
                }
            })
        },
        loadCardPics:function(){
            var _self = this;
            _self.loading = true;

            let data = {
              "dhid": _self.appinfo.dhid,
              "uhid": _self.appinfo.uhid,
              "vcode": _self.appinfo.vcode
            }
            let ed = AES.Encrypt( JSON.stringify(data), AES.obj())

            this.$http.post(_host + '/user/get',{
                ed: ed
            },{
                emulateJSON: true
            }).then(function(response){
                _self.loading = false;
                var json = response.body;
                if(json.c=='0000'){
                    var picUrlFront = json.m.u_card_front_thumb,
                        picUrlback = json.m.u_card_back_thumb;
                    if(picUrlFront){
                        $('.upload .item1').data('upload','true');
                        $('.upload .item1').addClass('uploaded');   
                    }
                    if(picUrlback){
                        $('.upload .item2').data('upload','true');
                        $('.upload .item2').addClass('uploaded');
                    }
                }else{
                    safe.model({
                        title:'温馨提示',
                        content:json.m,
                        foot:'我知道了'
                    });
                    safe.bindModelEvent();
                }
            })
        },
        loadPricePics:function(first,second){
            var _self = this;
            _self.loading = true;

            let data = {
              "id": _self.order_sn,
              "uhid": _self.appinfo.uhid
            }
            let ed = AES.Encrypt( JSON.stringify(data), AES.obj())
            this.$http.post(_host + '/safe/get_one',{
              ed: ed,
            },{
                emulateJSON: true
            }).then(function(response){
                _self.loading = false;
                var json = response.body;
                if(json.c=='0000'){
                    var picUrlPrice = json.m.price_info_thumb;
                    if(picUrlPrice){
                        $('.screenShot').data('upload','true');
                        $('.screenShot').addClass('uploaded');
                        $('.screenShot').addClass('screen');
                    }
                }else{
                    safe.model({
                        title:'温馨提示',
                        content:json.m,
                        foot:'我知道了'
                    });
                    safe.bindModelEvent();
                }
            })
        },
        bindEvent:function(){
            var _self = this;
            var params = 'uhid='+_self.appinfo.uhid+'&order_sn='+_self.order_sn;
            document.getElementById('uploadIDFront').onchange = function(){
                _self.applyAjaxFileUpload("uploadIDFront",params+'&file_id=uploadIDFront&type=front');
            };
            document.getElementById('uploadIDBack').onchange = function(){
                _self.applyAjaxFileUpload("uploadIDBack",params+'&file_id=uploadIDBack&type=back');
            };
            document.getElementById('uploadPrice').onchange = function(){
                _self.applyAjaxFileUpload("uploadPrice",params+'&file_id=uploadPrice&type=price');
            };
        },
        applyAjaxFileUpload:function(element,params){
          try{
            var obj = document.getElementById(element).files[0];
            console.log(`1234567`, obj.type)
            var str = obj.type;
            if(str.indexOf('image') < 0){
              Toast('上传的格式不正确')
              console.log("照片上传：文件类型必须是JPG、JPEG、PNG或GIF!");
              return
            }
          }catch (e) {
            return
            console.log("", e);
          }
          
            var _self = this;
            _self.loading = true;
            var url = _host + '/inc/upload_img?'+params;

            $.ajaxFileUpload({
                url: url,
                secureuri: false,
                fileElementId: element,
                dataType: 'json',
                success: function(response) {
                    if(element == "uploadPrice"){
                        setTimeout(function(){_self.loadPricePics();},3000);
                    }else{
                        setTimeout(function(){_self.loadCardPics();},3000);
                    }
                    _self.bindEvent();
                }
            });
        }
    }
}
</script>

<style scoped>
.doc_text {position: relative;}
.upload{padding-left: 6%;}
.upload .item{
    display: inline-block;
    position: relative;
    width: 100px;
    height: 100px;
    background-color: #ffffff;
    border:1px solid #dbdbdb;
    background-repeat: no-repeat;
    background-image: url(../images/id_no.png);
    -webkit-background-size: 40px 30px;
    background-size: 80px;
    background-position: center;
    margin-right: 10px;
    text-align: center;
}
.upload .uploaded{
    display: inline-block;
    position: relative;
    width: 100px;
    height: 100px;
    background-color: #ffffff;
    border:1px solid #dbdbdb;
    background-repeat: no-repeat;
    background-image: url(../images/id_ok.png);
    -webkit-background-size: 40px 30px;
    background-size: 80px;
    background-position: center;
    margin-right: 10px;
    text-align: center;
}

.upload .item button{position: absolute;background-color: #15cb73;width: 86px;height: 24px;border:none;color: #ffffff;font-size: 13px;bottom: 6px; margin-left: -43px; left: 50%;z-index: 1}
.upload .item .desc{display: none;}
.upload .item button:active{background-color: #12ae63;} 
.upload .item input[type=file]{opacity: 0; width: 100%; height: 100%; position: absolute; left: 0; top: 0; z-index: 2;}
.upload .screenShot{
    background-image: url(../images/cut_no.png);
}
.upload .screen{
    background-image: url(../images/cut_ok.png);
}

.upload .uploaded button{display: none}
.upload .uploaded .desc{display: block; position: absolute;width: 86px;height: 24px;border:none;color: #ooo;font-size: 13px;bottom: 0px; margin-left: -43px; left: 50%;z-index: 1}
</style>



// WEBPACK FOOTER //
// ClaimStep2.vue?68e71154